import { render, staticRenderFns } from "./ItemImportHelp.vue?vue&type=template&id=37ea05fd&scoped=true&lang=pug&"
import script from "./ItemImportHelp.vue?vue&type=script&lang=ts&"
export * from "./ItemImportHelp.vue?vue&type=script&lang=ts&"
import style0 from "./ItemImportHelp.vue?vue&type=style&index=0&id=37ea05fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea05fd",
  null
  
)

export default component.exports